<div class="input-group mb-5">
  <input
    type="text"
    [id]="inputId"
    class="form-control"
    [placeholder]="config.dateInputFormat || 'YYYY-MM-DD'"
    bsDatepicker
    #dp="bsDatepicker"
    [bsConfig]="config"
    [bsValue]="value"
    (bsValueChange)="onChangeValue($event)"
    triggers="dblclick:click"
    [disabled]="isDisabled"
    [isDisabled]="isDisabled"
    [readonly]="isReadonly"
    (input)="handleInput($event)"
  >
  <button
    type="button"
    class="p-element p-ripple p-datepicker-trigger p-button p-component p-button-icon-only input-group-text"
    (click)="dp.toggle()"
    [disabled]="isDisabled"
  >
    <span class="pi pi-calendar"></span>
  </button>
</div>
